import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useViewChargedDetailsContext } from '../../../hooks/useContexts';
import { IViewChargeHistoryResponse } from '../../../models/responses/oms';

export const ViewChargedTotalsDetails: React.FC = () => {
  const { chargeHistoryData } = useViewChargedDetailsContext();
  const greenKeys = ['Delivery Fees', 'Pick Up Fees', 'Pro Extra Savings'];

  // Map of field keys to display labels and value formatters if needed
  const fieldMap: Array<{
    key: keyof IViewChargeHistoryResponse;
    label: string;
  }> = [
    { key: 'subTotal', label: 'Subtotal' },
    { key: 'deliveryFees', label: 'Delivery Fees' },
    { key: 'pickUpFees', label: 'Pick Up Fees' },
    { key: 'proExtraSavings', label: 'Pro Extra Savings' },
    { key: 'preTaxTotal', label: 'Pre-Tax Total' },
    { key: 'salesTax', label: 'Sales Tax' },
  ];

  const chargeDetails = chargeHistoryData
    ? fieldMap
        .filter(
          ({ key }) =>
            chargeHistoryData[key] !== undefined &&
            chargeHistoryData[key] !== null &&
            chargeHistoryData[key] !== '',
        )
        .map(({ key, label }) => ({
          key: label,
          value: chargeHistoryData[key] as string,
        }))
    : [];

  return (
    <div className="sui-flex sui-flex-col sui-w-full sui-p-4">
      {chargeDetails.map(({ key, value }) => (
        <div key={key} className="sui-w-full sui-flex sui-justify-between">
          <Typography>{key}</Typography>
          <Typography color={greenKeys.includes(key) ? 'success' : 'default'}>
            {value}
          </Typography>
        </div>
      ))}
    </div>
  );
};
